<button mat-menu-item
        id="{{data()?.id}}"
        [inspektRequiredPermission]="data()?.permissions">
    <mat-icon>{{data()?.icon}}</mat-icon>
    <span>{{data()?.title}}</span>
</button>

